import { ICreateSaidaMultiPUseCase } from "../../../presentation/useCases/create/create_saida_produtos_multi_use_case";
import { IEstoqueRepository } from "../../repositories/estoque_repository";

export class CreateSaidaMultiPUseCase implements ICreateSaidaMultiPUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async createSaidaMultiP(
    Data?: Date | null,
    IdCentroCusto?: number | null,
    IdCentroCustoDestino?: number | null,
    IdProdutoServicoM?: number[] | null,
    NroNotaFiscal?: string | null,
    Quantidade?: number | null,
    IdFornecedor?: number | null,
    IdFuncionario?: number | null,
    NrNotaFiscal?: string | null,
    IdSessaoMultipla?: string | null,
    Delete?: boolean | null,
    ValorUnitario?: number | null,
    localAplicacao?: string | null,
  ): Promise<number> {
    const response = await this.repository.createSaidaMultiP(
      Data,
      IdCentroCusto,
      IdCentroCustoDestino,
      IdProdutoServicoM,
      NroNotaFiscal,
      Quantidade,
      IdFornecedor,
      IdFuncionario,
      NrNotaFiscal,
      IdSessaoMultipla,
      Delete,
      ValorUnitario,
      localAplicacao,
    );

    return response.idSessaoMultipla;
  }
}
